"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadcrumbNavigation = exports.BreadcrumbNavigationDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_lang_1 = require("../../hooks/use-lang");
var use_theme_1 = require("../../hooks/use-theme");
var use_sidebar_1 = require("../../hooks/use-sidebar");
var use_app_screen_1 = require("../../hooks/use-app-screen");
var lodash_1 = require("lodash");
var secondary_navigation_1 = require("./secondary-navigation");
var react_spinners_1 = require("react-spinners");
var badge_1 = require("./badge");
exports.BreadcrumbNavigationDefaultProps = {
  depth: 'list'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    margin-top: 22px;\n  "], ["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    margin-top: 22px;\n  "])))
});
var NavigationStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var hasIndent = _a.hasIndent;
    return hasIndent && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding-left: ", ";\n    "], ["\n      padding-left: ", ";\n    "])), theme_1.theme.UNIT(4));
  })
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-shrink: 0;\n    margin-left: ", ";\n  "], ["\n    flex-shrink: 0;\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var SpinnerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var NameAndBadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 60px;\n  "], ["\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 60px;\n  "]))),
  landscape: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    max-width: 200px;\n  "], ["\n    max-width: 200px;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    max-width: 350px;\n  "], ["\n    max-width: 350px;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    max-width: 450px;\n  "], ["\n    max-width: 450px;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Navigation: (0, styled_components_1.default)(secondary_navigation_1.SecondaryNavigation)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), NavigationStyles),
  NameAndBadge: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), NameAndBadgeStyles),
  Badge: (0, styled_components_1.default)(badge_1.Badge)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles),
  Name: styled_components_1.default.span(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Controls: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  Spinner: (0, styled_components_1.default)(react_spinners_1.ClipLoader)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), SpinnerStyles)
};
var BreadcrumbNavigation = function (props) {
  var _a;
  var className = props.className,
    entity = props.entity,
    loading = props.loading,
    depth = props.depth,
    controls = props.controls,
    badge = props.badge;
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var t = (0, use_lang_1.useLang)();
  var color = (0, use_theme_1.useTheme)().color;
  var sidebar = (0, use_sidebar_1.useSidebar)();
  var isSidebarShown = (_a = sidebar === null || sidebar === void 0 ? void 0 : sidebar.state) === null || _a === void 0 ? void 0 : _a.isShown;
  var screen = (0, use_app_screen_1.useAppScreen)();
  var items = [];
  // Add the entity listing link
  if ((0, lodash_1.includes)(['details', 'list'], screen.type)) {
    items.push({
      icon: definition && function (_a) {
        var icons = _a.icons;
        return icons.Entities[definition.name] || icons.Target;
      },
      label: definition.pluralLabel,
      to: definition.toList(),
      isActive: screen.type !== 'list',
      isCurrent: screen.type === 'list'
    });
  }
  // push the details breadcrumb, which shows either loading spinner or entity name
  if (screen.type === 'details') {
    if (entity) {
      var label = react_1.default.createElement(My.NameAndBadge, null, react_1.default.createElement(My.Name, {
        title: entity.name
      }, entity.name), badge && react_1.default.createElement(My.Badge, null, badge));
      items.push({
        isCurrent: true,
        isActive: false,
        to: definition.to(entity.slug),
        label: label
      });
    } else {
      items.push({
        isCurrent: true,
        label: react_1.default.createElement(My.Spinner, {
          size: 10,
          color: "#00000033"
        })
      });
    }
  }
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Navigation, {
    hasIndent: isSidebarShown && !(sidebar === null || sidebar === void 0 ? void 0 : sidebar.isFloating),
    divider: "chevron",
    items: items
  }), controls && react_1.default.createElement(My.Controls, null, controls));
};
exports.BreadcrumbNavigation = BreadcrumbNavigation;
exports.BreadcrumbNavigation.defaultProps = exports.BreadcrumbNavigationDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;